<div #taskContainer class="layout-row layout-align-start-end layout-wrap">
  <ng-container *ngIf="!!viewItems?.length">
    <div *ngFor="let taskSequenceData of viewItems"
         class="layout-column layout-align-end-center margin-bottom-5" (click)="$event.stopPropagation();">

      <ng-container *ngIf="!taskSequenceData.isExtraInfo">
        <span class="dot-box" [ngbTooltip]="'Out of order' | translate" openDelay="300" triggers="hover"
              container="body"
              [ngClass]="{'hidden': !taskSequenceData.isOutOfOrder }"></span>
        <div class="sequence-task layout-row layout-align-center-center margin-right-5 position-relative"
             [ngbTooltip]="tooltipTmpl" container="body" openDelay="300" triggers="hover"
             [style.width.px]="taskSequenceData.details.bundleServiceIdList?.length > 1 ? 45 : 25"
             [ngClass]="{'canceled-task': taskSequenceData.isCancelled, 'not-started': taskSequenceData.details.status === 'Assigned'}">

          <span *ngIf="taskSequenceData.taskType !== 'Internal'">{{taskSequenceData.number}}</span>
          <div *ngIf="taskSequenceData.taskType === 'Internal'">
            <span *ngIf="taskSequenceData.taskPurpose === 'StartRoute'">S</span>
            <span *ngIf="taskSequenceData.taskPurpose === 'EndRoute'">E</span>
          </div>

          <div *ngIf="taskSequenceData.details.bundleServiceIdList?.length > 1"
               class="margin-left-5 layout-row position-relative bundle-indication"
               [style.width.px]="getBundleIndicationWidth(taskSequenceData.details.bundleServiceIdList?.length)">
            <bringoz-icon iconName="layers" classSize="md"></bringoz-icon>
            <span class="bundle-count">{{taskSequenceData.details.bundleServiceIdList?.length}}</span>
          </div>

        </div>
        <ng-template #tooltipTmpl>
          <div class="layout-column">
            <div class="layout-row layout-align-start-center margin-bottom-5">
              <app-task-status class="margin-right-5" [status]="taskSequenceData.details.status"
                               [small]="true"></app-task-status>
              <app-task-purpose class="margin-right-5"
                                [isBundle]="taskSequenceData.details.bundleServiceIdList?.length > 1"
                                [purpose]="taskSequenceData.details.taskSpec?.purpose || taskSequenceData.details.purpose"></app-task-purpose>
              <span *ngIf="taskSequenceData.details.bundleServiceIdList?.length > 1"
                    class="br-body-1 font-weight-400 primary-100">x{{taskSequenceData.details.bundleServiceIdList?.length}}</span>
              <span class="flex"></span>
              <span class="br-body-1">{{taskSequenceData.details.serviceId}}</span>
            </div>

            <div *ngIf="!!tasksExtraDataMap[taskSequenceData.details.id].createdBy?.source && tasksExtraDataMap[taskSequenceData.details.id].createdBy?.source === 'Agent'"
                 class="creation-source margin-bottom-5 layout-row layout-align-start-center">
              <bringoz-icon iconName="edit-outline" class="margin-right-5"></bringoz-icon>
              <span class="br-caption-1 font-weight-500">{{'By' | translate}} {{ tasksExtraDataMap[taskSequenceData.details.id].createdBy.source | translate}}</span>
            </div>

            <div *ngIf="!!tasksExtraDataMap[taskSequenceData.details.id].accountReference?.name"
                 class="layout-row layout-align-start-center margin-bottom-5">
              <bringoz-icon iconName="account" class="margin-right-5 gray-102"></bringoz-icon>

              <span class="br-body-2 font-weight-400">{{tasksExtraDataMap[taskSequenceData.details.id].accountReference.name}}</span>

              <!--              <span-->
              <!--                *ngIf="taskSequenceData.details.taskSpec.locationDetails.locationType === locationTypes.DEPOT">{{taskSequenceData.details.taskSpec.depotReference.name}}</span>-->

              <!--              <span appBringozPpi-->
              <!--                    class="br-body-2 font-weight-400 margin-left-5">-->
              <!--                {{taskSequenceData.details.taskSpec.contact.phoneNo | bringozPhone}}</span>-->
            </div>

            <div *ngIf="taskSequenceData.details.taskType !== 'Internal'" class="layout-column">
              <div class="layout-row layout-align-start-center margin-bottom-5">
                <bringoz-icon iconName="BOX" class="margin-right-5 gray-102"></bringoz-icon>
                <span
                        class="br-body-2 font-weight-400">{{tasksExtraDataMap[taskSequenceData.details.id].packagesExtraData.taskPackagesCount}} {{'Packages' | translate}}</span>
              </div>

              <div class="layout-row layout-align-start-center">
                <bringoz-icon iconName="weight" class="margin-right-5 gray-102"></bringoz-icon>
                <span
                        class="br-body-2 font-weight-400">{{tasksExtraDataMap[taskSequenceData.details.id].packagesExtraData.taskTotalWeight}} {{siteUnit}}</span>
              </div>
            </div>
          </div>
          <!--                    <app-task-info [task]="taskSequenceData.details"></app-task-info>-->
        </ng-template>
      </ng-container>

      <ng-container *ngIf="taskSequenceData.isExtraInfo">
      <span class="extra-items-indication"
            [ngbTooltip]="extraItemsTooltip" container="body"
            openDelay="300" triggers="hover">+{{extraItems.length}}</span>
        <ng-template #extraItemsTooltip>
          <div class="layout-row">
            <div *ngFor="let taskSequenceData of extraItems; let last = last"
                 class="task-container layout-column layout-align-end-center">
              <span class="dot-box" [ngbTooltip]="'Out of order' | translate" container="body" openDelay="300"
                    triggers="hover" [ngClass]="{'hidden': !taskSequenceData.isOutOfOrder }"></span>
              <div class="sequence-task layout-row layout-align-center-center margin-right-5 position-relative"
                   [style.width.px]="taskSequenceData.details.bundleServiceIdList?.length > 1 ? 45 : 25"
                   [ngClass]="{'canceled-task': taskSequenceData.isCancelled, 'not-started': taskSequenceData.details.status === 'Assigned'}">
                <span *ngIf="taskSequenceData.taskType !== 'Internal'">{{taskSequenceData.number}}</span>
                <div *ngIf="taskSequenceData.taskType === 'Internal'">
                  <span *ngIf="taskSequenceData.taskPurpose === 'StartRoute'">S</span>
                  <span *ngIf="taskSequenceData.taskPurpose === 'EndRoute'">E</span>
                </div>
                <div *ngIf="taskSequenceData.details.bundleServiceIdList?.length > 1"
                     class="margin-left-5 layout-row position-relative bundle-indication"
                     [style.width.px]="getBundleIndicationWidth(taskSequenceData.details.bundleServiceIdList?.length)">
                  <bringoz-icon iconName="layers" classSize="md"></bringoz-icon>
                  <span class="bundle-count">{{taskSequenceData.details.bundleServiceIdList?.length}}</span>
                </div>
              </div>
            </div>
          </div>
        </ng-template>
      </ng-container>
    </div>
  </ng-container>
</div>

